import { Form, Field } from 'react-final-form';
import ReactGA from 'react-ga';
import { useContext } from 'react';

import * as Styled from './right-content.styles';
import {
    composeValidators,
    fieldRequired,
    maxLength,
    ToastContext,
    validateEmail,
} from '../../../../../../shared/helpers';
import { FieldError } from '../../../../../../shared/components';
import { ICON_TYPES } from '../../../../../../shared/ui-kit';
import { BookCallService } from '../../../../../../shared/services';
import { useNavigate } from 'react-router-dom';

const FormValuesFields = {
    name: 'name',
    email: 'email',
    company: 'company',
    message: 'message',
};

const fields = [
    {
        name: FormValuesFields.name,
        placeholder: 'Name',
        type: 'text',
        validate: fieldRequired,
    },
    {
        name: FormValuesFields.company,
        placeholder: 'Company',
        type: 'text',
        validate: () => {},
    },
    {
        name: FormValuesFields.email,
        placeholder: 'Email',
        type: 'email',
        validate: composeValidators(fieldRequired, validateEmail),
    },
    {
        name: FormValuesFields.message,
        placeholder: 'Briefly describe your question',
        type: 'text',
        validate: maxLength(500),
    },
];

const RightContent = () => {
    const onSubmit = (values) => {
        return BookCallService.bookCall(values);
    };
    const navigate = useNavigate();

    const { open } = useContext(ToastContext);

    const errorNotification = () => {
        open({ type: 'Error', content: 'Something went wrong. Please try again!' });
    };

    return (
        <Styled.Container>
            <Form
                onSubmit={onSubmit}
                render={({ handleSubmit, submitting, form }) => (
                    <form
                        onSubmit={(event) => {
                            const promise = handleSubmit(event);
                            if (promise) {
                                promise
                                    .then(() => {
                                        ReactGA.event({
                                            category: 'User',
                                            action: "User filled a 'Book a call form' and sent a request",
                                        });
                                        Object.keys(FormValuesFields).forEach((key) => {
                                            form.change(key, undefined);
                                            form.resetFieldState(key);
                                        });
                                        navigate('/thank-you', { state: { isFromApp: true } });
                                    })
                                    .catch(() => {
                                        errorNotification();
                                    });
                                return promise;
                            }
                        }}>
                        {fields.map(({ name, validate, type, placeholder }) => (
                            <Field name={name} validate={validate} key={name}>
                                {({ input, meta }) => (
                                    <Styled.FieldBlock>
                                        <Styled.FieldInput
                                            isError={meta.touched && meta.error}
                                            type={type}
                                            {...input}
                                            placeholder={placeholder}
                                        />
                                        <FieldError meta={meta} />
                                    </Styled.FieldBlock>
                                )}
                            </Field>
                        ))}

                        <Styled.SubmitButton type='submit' disabled={submitting} icon={ICON_TYPES.whitePhone}>
                            <Styled.SubmitButtonText>Book a call</Styled.SubmitButtonText>
                        </Styled.SubmitButton>
                    </form>
                )}
            />
        </Styled.Container>
    );
};

export default RightContent;
